import { render, staticRenderFns } from "./msg-bar.vue?vue&type=template&id=085cac1a&scoped=true"
import script from "./msg-bar.vue?vue&type=script&lang=js"
export * from "./msg-bar.vue?vue&type=script&lang=js"
import style0 from "./msg-bar.vue?vue&type=style&index=0&id=085cac1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085cac1a",
  null
  
)

export default component.exports